import React, { useState } from "react";
import { rejectedSvg, submittedSvg } from "../utils/svg";
import { CircleCheck } from "lucide-react";
import Button from "../utils/Button";
import { Modal } from "../utils/Modal";
import { loader } from "../utils/svg";

const SuccessRejectionScreen = ({
  isRejected,
  isSuccess,
  heading,
  message,
  rejectionReason = [],
  rejectionDetails = [],
  successMessage,
  successDetails,
  buttonAction,
  rejectionLoader,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return rejectionLoader ? (
    <div className="flex flex-col gap-6 justify-center items-center">
      {loader()}
    </div>
  ) : (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col items-center gap-3">
        <>{isSuccess ? submittedSvg() : isRejected ? rejectedSvg() : ""}</>
        <p className="text-lg font-bold text-gray-500">{heading}</p>
        <p className="text-md text-gray-400 text-center">{message}</p>
      </div>
      <div
        className={`p-4 rounded flex flex-col gap-1.5 ${
          isSuccess
            ? "bg-[#ECFFEB]"
            : isRejected
              ? "bg-[#FFEBED]"
              : "bg-[white]"
        }`}
      >
        <p className="text-sm font-bold text-gray-500">
          {isSuccess ? "What's next?" : isRejected ? "Why was I rejected?" : ""}
        </p>
        <p className="text-sm text-gray-400">
          {isSuccess
            ? successMessage
              ? successMessage
              : ""
            : isRejected
              ? rejectionReason?.length > 0
                ? rejectionReason?.map((reason) => (
                    <p className="mb-1">{reason}</p>
                  ))
                : ""
              : ""}
        </p>
      </div>
      <div className="flex flex-col gap-1.5">
        <p className="text-sm font-bold text-gray-500">
          {isSuccess ? "Application Details:" : isRejected ? "You can:" : ""}
        </p>
        <p className="text-sm text-gray-400">
          {isSuccess ? (
            successDetails?.length > 0 ? (
              <>
                {successDetails?.map((detail, index) => (
                  <p className="flex gap-1.5 mb-1">
                    <p className="text-green-600">
                      <CircleCheck size={20} />
                    </p>
                    {detail}
                  </p>
                ))}
              </>
            ) : (
              ""
            )
          ) : isRejected ? (
            rejectionDetails?.length > 0 ? (
              <>
                {rejectionDetails?.map((detail, index) => (
                  <p className="mb-1">{` ${index + 1}. ${detail}`}</p>
                ))}
              </>
            ) : (
              ""
            )
          ) : (
            ""
          )}
        </p>
      </div>

      <div>
        {isSuccess ? (
          <div>
            <Button text={"Done"} size={"md"} onClick={buttonAction} />
          </div>
        ) : isRejected ? (
          <div className="flex flex-col items-center gap-1.5">
            <Button text={"Done"} size={"md"} onClick={buttonAction} />
            <p
              className="text-sm text-gray-400 cursor-pointer"
              onClick={() => setIsModalOpen(true)}
            >
              Contact Support
            </p>
            <Modal
              isOpen={isModalOpen}
              header={"Contact Support"}
              message={
                "Please reach out to obc@scienslogistics.com if you have any issues or assistance. Thank you. "
              }
              buttonTitle={"Close"}
              buttonAction={() => setIsModalOpen(false)}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default SuccessRejectionScreen;
